"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importDefault(require("react"));

var SvgBold = function SvgBold(props) {
  return react_1.default.createElement("svg", __assign({
    width: '1em',
    height: '1em',
    viewBox: '0 0 24 24'
  }, props), react_1.default.createElement("path", {
    d: 'M7 17.002V7.011C7 5.671 7.668 5 9.005 5h2.747c.892 0 1.652.09 2.278.269.627.18 1.138.432 1.534.76.396.326.684.723.864 1.19.18.468.27.99.27 1.567 0 .314-.04.616-.124.908a2.761 2.761 0 0 1-.39.821 3.026 3.026 0 0 1-.682.697c-.278.208-.612.39-1.002.543.851.224 1.48.588 1.888 1.09.408.503.612 1.149.612 1.937a4.27 4.27 0 0 1-.32 1.662c-.212.513-.524.96-.934 1.34a4.33 4.33 0 0 1-1.52.894c-.604.215-1.292.322-2.066.322H9.015C7.672 19 7 18.334 7 17.002zm2.996-3.94v3.488h2.11c.396 0 .72-.055.971-.164.251-.108.448-.25.59-.422.142-.173.239-.369.292-.587.053-.217.08-.438.08-.663 0-.256-.031-.486-.093-.691a1.154 1.154 0 0 0-.32-.52c-.15-.14-.35-.25-.598-.326-.248-.077-.561-.115-.94-.115H9.997zm0-2.172h1.56c.332 0 .63-.025.896-.077.266-.05.492-.14.678-.269a1.21 1.21 0 0 0 .426-.528c.097-.224.146-.506.146-.846 0-.333-.038-.61-.115-.83a1.191 1.191 0 0 0-.355-.534 1.435 1.435 0 0 0-.607-.288 3.857 3.857 0 0 0-.873-.087H9.996v3.46z'
  }));
};

exports.default = SvgBold;